import { API_BASE_URL } from "../urls.api";

const buildUserIdQuery = (userId?: string) => (userId ? `?userId=${userId}` : "");

export const getGuestyListingsUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/guesty/listings${buildUserIdQuery(userId)}`;

export const getAvantioAccommodationsUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/avantio/accommodations${buildUserIdQuery(userId)}`;

export const getLinkCustomerGuestyUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/guesty/linkcustomer${buildUserIdQuery(userId)}`;

export const getUnlinkCustomerGuestyUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/guesty/unlinkcustomer${buildUserIdQuery(userId)}`;

export const getLinkCustomerKrossUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/kross/linkcustomer${buildUserIdQuery(userId)}`;

export const getUnlinkCustomerKrossUrl = (customerId: string, userId?: string) =>
  `${API_BASE_URL}/third-parties/kross/unlinkcustomer/${customerId}${buildUserIdQuery(userId)}`;

export const getKrossRoomsUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/kross/accommodations${buildUserIdQuery(userId)}`;

export const getLinkCustomerHostifyUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/hostify/linkcustomer${buildUserIdQuery(userId)}`;

export const getUnlinkCustomerHostifyUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/hostify/unlinkcustomer${buildUserIdQuery(userId)}`;

export const getHostifyListingsUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/hostify/listings${buildUserIdQuery(userId)}`;

export const getLinkCustomerIcneaUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/icnea/linkcustomer${buildUserIdQuery(userId)}`;

export const getUnlinkCustomerIcneaUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/icnea/unlinkcustomer${buildUserIdQuery(userId)}`;

export const getUpdateIcneaPasswordUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/icnea/updatepassword${buildUserIdQuery(userId)}`;

export const getIcneaPropertiesUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/icnea/properties${buildUserIdQuery(userId)}`;

export const getIcneaStatusUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/icnea/status${buildUserIdQuery(userId)}`;

export const getRefreshGuestyCredentialsUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/guesty/refresh-credentials${buildUserIdQuery(userId)}`;

export const getLinkCustomerHostawayUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/hostaway/linkcustomer${buildUserIdQuery(userId)}`;

export const getUnlinkCustomerHostawayUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/hostaway/unlinkcustomer${buildUserIdQuery(userId)}`;

export const getHostawayListingsUrl = (userId?: string) =>
  `${API_BASE_URL}/third-parties/hostaway/accommodations${buildUserIdQuery(userId)}`;
